import { Link } from "react-router-dom";
import { useSeo } from "../lib/useSeo";

const SECTIONS = [
  {
    title: "Main Pages",
    links: [
      ["Home", "/"], ["Search by Category", "/categories"], ["Popular AI Tools", "/ai-tools"],
      ["Our Partners", "/partners"], ["Become a Partner", "/become-a-partner"],
      ["For Teams & Enterprise", "/enterprise"], ["Refer a Friend", "/refer-a-friend"],
      ["Prompt Queen Tips", "/prompt-queen-tips"],
      ["Pricing & Membership", "/pricing"], ["Blog", "/blog"], ["Register", "/register"], ["Login", "/login"],
    ],
  },
  {
    title: "About & Help",
    links: [["About", "/about"], ["Contact", "/contact"], ["FAQ", "/faq"]],
  },
  {
    title: "Legal",
    links: [
      ["Privacy Policy", "/privacy"], ["Terms of Service", "/terms"],
      ["Subscription Terms", "/subscription-terms"], ["Partner Programme Terms", "/partner-terms"],
      ["AI Disclaimer", "/ai-disclaimer"], ["Cookies", "/cookies"],
    ],
  },
];

export default function SitemapPage() {
  useSeo({
    title: "Sitemap — All Pages",
    description: "Browse the main pages on AI Prompt Shortcuts: search by category, popular AI tools, pricing, blog and legal information.",
  });

  return (
    <div className="bg-[#FAFAF7] min-h-screen py-14 lg:py-20 px-4 sm:px-6 lg:px-8" data-testid="sitemap-page">
      <div className="max-w-5xl mx-auto">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Sitemap</h1>
        <p className="text-slate-500 mt-3 text-sm sm:text-base">The main pages on AI Prompt Shortcuts, in one place.</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 mt-10">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-display font-bold text-lg text-slate-900">{s.title}</h2>
              <ul className="mt-3 space-y-2">
                {s.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-emerald-700 font-medium hover:underline">{label}</Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <p className="text-xs text-slate-400 mt-14">
          Looking for the machine-readable version? Search engines can use our{" "}
          <a href="/api/sitemap.xml" className="text-emerald-700 hover:underline" target="_blank" rel="noopener noreferrer">XML sitemap</a>.
        </p>
      </div>
    </div>
  );
}
